export const monthAbbreviations = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"];

export const months = [
    {month:"January",value:1},
    {month:"February",value:2},
    {month:"March",value:3},
    {month:"April",value:4},
    {month:"May",value:5},
    {month:"June",value:6},
    {month:"July",value:7},
    {month:"August",value:8},
    {month:"September",value:9},
    {month:"October",value:10},
    {month:"November",value:11},
    {month:"December",value:12},
];

export const years = [
    2021,
    2022,
    2023,
    2024,
    2025,
    2026,
    2027
];